import type { ReactNode } from 'react';
import { ChevronIcon } from '../icons';
import { Card, type CardTone } from './Card';
import styles from './ui.module.css';

/**
 * Карточка, которая нажимается целиком.
 *
 * Заводится по факту: три экрана подряд упёрлись в это и обошли тремя
 * разными способами — кнопкой «Разобрать» внизу карточки, вкуишным Tappable
 * (то есть div с role="button") и вовсе без перехода. Одинаковые по смыслу
 * списки стали вести себя по-разному.
 *
 * Внутри настоящий <button>: div с onClick пропускает Tab и не виден
 * скринридеру, а голая кнопка без сброса рисует браузерные рамку и фон —
 * глобального ресета в проекте нет, и vkui.css его не даёт.
 *
 * `chevron` ставит стрелку у правого края: без неё строка, ведущая на другой
 * экран, ничем не отличается от карточки-сводки, которая никуда не ведёт.
 * Плитке реестра она не нужна — там на переход намекает сам кадр.
 */
export function CardLink({
  children,
  onClick,
  label,
  tone = 'default',
  padded = true,
  chevron = false,
}: {
  children: ReactNode;
  onClick: () => void;
  /** Что откроется: читалке с экрана заголовка внутри карточки мало. */
  label: string;
  tone?: CardTone;
  /**
   * Отступы внутри. Снимают там, где содержимое идёт от края: плитка с
   * изображением во всю ширину.
   */
  padded?: boolean;
  chevron?: boolean;
}) {
  return (
    <button type="button" className={styles.reset} aria-label={label} onClick={onClick}>
      <Card tone={tone} padded={padded}>
        {chevron ? (
          <div className={styles.cardLinkRow}>
            <div className={styles.cardLinkBody}>{children}</div>
            <span className={styles.cardLinkChevron}>
              <ChevronIcon />
            </span>
          </div>
        ) : (
          children
        )}
      </Card>
    </button>
  );
}
